import { Banner } from '../types/banner';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

dayjs.locale('es');

export const formatDate = (date: Date): string => {
  return dayjs(date).format('D [de] MMMM');
};

export const getBannerDate = (banner: Banner): string => {
  const config = banner.creativityConfig;

  if (config && 'date' in config && config.date) {
    const date = new Date(config.date);
    const day = 'day' in config && config.day ? config.day.split(' - ')[0] : '';
    const formattedDate = formatDate(date);
    return day ? `${day} ${formattedDate}` : formattedDate;
  }

  // Fallback a createdAt
  return formatDate(new Date(banner.createdAt));
};
